import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalUiGlideModule } from "@obg/ngx.ui.global.glide";

import { ServerStyleModule } from "../server-style/server-style.module";

import { CommonBannerSlideComponent } from "./banner-slide/banner-slide.component";
import { LgBannerComponent } from "./lg-banner.component";
import { LgBannerConfigService } from "./lg-banner.config";

const DIRECTIVES = [LgBannerComponent, CommonBannerSlideComponent];

@NgModule({
	imports: [CommonModule, CoreContentModule, GlobalUiGlideModule, ServerStyleModule],
	providers: [LgBannerConfigService],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class BannerModule {}
